import React, { forwardRef } from 'react';
import {
    PopupMenu,
    PopupHeader,
    PopupTitle,
    PopupBody,
    ReleaseDescription,
    ReleaseContent,
    ReleaseTitle,
    ReleaseDate
} from './release-note-styled-components.js';
import { formatSeasonDate } from 'utils/helpers/date-utils.js';

// forwardRef: a ref read from the props never arrives, so a click in the notes counted as outside and closed them
const ReleaseNoteModel = forwardRef(({ releaseData }, ref) => {
    return (
        <PopupMenu ref={ref}>
            <PopupHeader>
                <PopupTitle>What's New</PopupTitle>
            </PopupHeader>
            <PopupBody>
                {releaseData?.map((el, key) => (
                    // eslint-disable-next-line react/no-array-index-key -- TODO: legacy index key (baseline)
                    <ReleaseContent key={key}>
                        <ReleaseTitle>{el.title}</ReleaseTitle>
                        <ReleaseDescription>{el.description}</ReleaseDescription>
                        <ReleaseDate>{formatSeasonDate(el.created)}</ReleaseDate>
                    </ReleaseContent>
                ))}
            </PopupBody>
        </PopupMenu>
    );
});

export default ReleaseNoteModel;
